export default __webpack_public_path__ + "8ecff44637bb29b13ae3b6dc69c5cdb7.svg";